import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
  faTachometerAlt,
  faTools,
  faNetworkWired,
  faList,
  faCogs,
  faServer,
  faSignOutAlt,
  faGlobe
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "./Sidebar.css";

const Sidebar = ({ onLogout, children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const location = useLocation();

  // ইউজার রোল রিড করা
  const userRole = localStorage.getItem('userRole') || 'viewer';

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  // Menu active check
  const isActive = (path) => {
    if (path === "/") return location.pathname === "/" ? "active-nav" : "";
    return location.pathname.startsWith(path) ? "active-nav" : "";
  };

  return (
    <>
      <button 
        className="sidebar-toggle-btn" 
        onClick={toggleSidebar}
        style={{ left: isSidebarOpen ? "235px" : "15px" }}
      >
        <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} size="lg" />
      </button>

      <div className="dashboard-layout">
        <div className={`sidebar ${isSidebarOpen ? "visible" : ""}`}>
          
          <div className="sidebar-header">
            <Link to="/" className="brand-link">
              <div className="brand-container">
                <img src="/n-tools.png" alt="Logo" className="sidebar-logo" />
                <p className="brand-slogan">
                  {t("Simplifying Diagnostics, Amplifying Performance")}
                </p>
              </div>
            </Link>
          </div>

          <nav className="sidebar-nav">
            {/* Overview */}
            <Link to="/" className={`nav-item ${isActive("/")}`}>
              <FontAwesomeIcon icon={faTachometerAlt} className="nav-icon" />
              <span>{t("Overview")}</span>
            </Link>

            {/* Info Manage */}
            <Link to="/info-manage" className={`nav-item ${isActive("/info-manage")}`}>
              <FontAwesomeIcon icon={faCogs} className="nav-icon" />
              <span>{t("Info Manage")}</span>
            </Link>

            {/* Device Manage */}
            <Link to="/device-manage" className={`nav-item ${isActive("/device-manage")}`}>
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              <span>{t("Device Manage")}</span>
            </Link>

            {/* Diagnostic Tools */}
            <Link to="/diagnostic-tools" className={`nav-item ${isActive("/diagnostic-tools")}`}>
              <FontAwesomeIcon icon={faTools} className="nav-icon" />
              <span>{t("Diagnostic Tools")}</span>
            </Link>

            {/* Log Manage */}
            <Link to="/log-manage" className={`nav-item ${isActive("/log-manage")}`}>
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              <span>{t("Log Manage")}</span>
            </Link>

            {/* Traffic Monitor */}
            <Link to="/traffic-monitor" className={`nav-item ${isActive("/traffic-monitor")}`}>
              <FontAwesomeIcon icon={faNetworkWired} className="nav-icon" />
              <span>{t("Traffic Monitor")}</span>
            </Link>

            {/* OLT Manage */}
            <Link to="/olt-manage" className={`nav-item ${isActive("/olt-manage")}`}>
              <FontAwesomeIcon icon={faServer} className="nav-icon" />
              <span>{t("OLT Manage")}</span>
            </Link>

          </nav>

          <div className="sidebar-footer">
            <div className="lang-box">
              <FontAwesomeIcon icon={faGlobe} size="sm" />
              <select onChange={handleLanguageChange} value={i18n.language}>
                <option value="en">English</option>
                <option value="bn">বাংলা</option>
              </select>
            </div>

            <button className="logout-button" onClick={onLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
              {t("Logout")}
            </button>
          </div>
        </div>

        <div className={`main-content ${isSidebarOpen ? "sidebar-open" : ""}`}>
          {children}
        </div>
      </div>
    </>
  );
};

export default Sidebar;